
import React, { Component } from 'react'
import Moment from 'react-moment'
import {translate} from 'react-i18next'
import ActionModal from '../../../../../common/ActionModal'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import {FACTOR_EFFECTS} from '../../../../../../constants'
import {FACTOR_IMPORTANCE} from '../../../../../../constants'

import {recallSession} from '../../../../../../api'

class ViewProfileModal extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    recallSession(this.props.sessionID)
      .then(profile => {
        const state = {...this.state}
        this.setState({state, ...profile})
      })
      .catch(error => this.setState({ error }))
  }

  getWeightText(index) {
    return FACTOR_EFFECTS.text[FACTOR_EFFECTS.weights.indexOf(this.state.topThreeWeights[index])]
  }

  getCompareText(index) {
    return FACTOR_IMPORTANCE.text[FACTOR_IMPORTANCE.weights.indexOf(this.state.topThreeCompare[index])]
  }

  renderEthnicity() {
    const { ethnicity } = this.state
    if (ethnicity === true) {
      return 'Yes'
    } else if (ethnicity === false) {
      return 'No'
    } else {
      return ''
    }
  }

  render() {
    const { t, open, dismissFn } = this.props
    return (
      <ActionModal
        open={open}
        content={this.state.decisionName ? this.getProfileView() : 'Loading'}
        dismissText={t('Close Window')}
        onDismiss={dismissFn}
        styles={{height:"80%"}}
        />
    )
  }

  getProfileView() {
    const { t } = this.props

    return (
    <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        align="left"
        spacing={16}
      >

        <Grid item xs={10}>
          <Typography align="center" variant="headline">{this.state.decisionName}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Case ID')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.caseId}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Medical Record Number')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.medicalRecordNumber}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Name')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.firstName} {this.state.lastName}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Date of Report')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            <Moment format='MM-DD-YY h:mm a'>{new Date(this.state.startTime)}</Moment>
            &nbsp;-&nbsp;
            {this.state.endTime !== "" && (
              <Moment format='MM-DD-YY h:mm a'>{new Date(this.state.endTime)}</Moment>
            )}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Option', {OPTIONNUM: 1})}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.options[0]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Option', {OPTIONNUM: 2})}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.options[1]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Information Reviewed')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.informationReviewed === 1 ? 'Yes' : 'No'}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Factors Supporting Option', {OPTIONNUM: 1})}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography></Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">1.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[0]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">2.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[1]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">3.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[2]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">4.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[3]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">5.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[4]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Factors Supporting Option', {OPTIONNUM: 2})}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography></Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">1.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[5]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">2.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[6]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">3.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[7]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">4.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[8]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">5.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[9]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Top Factors')}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography></Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">1.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[this.state.topThreeFactors[0]]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">2.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[this.state.topThreeFactors[1]]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">3.</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.factors[this.state.topThreeFactors[2]]}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 1')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getWeightText(0))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 2')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getWeightText(1))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 3')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getWeightText(2))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 1 is than 2')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getCompareText(0))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 2 is than 3')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getCompareText(1))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Influence of Factor 1 is than 3')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t(this.getCompareText(2))}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Results')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{Math.round(this.state.finalWeight*1000)/1000}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Participant Comments')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.userComments}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Date of Birth')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            {!!this.state.dateOfBirth.length && (
              <Moment format='MM-DD-YYYY'>{new Date(this.state.dateOfBirth)}</Moment>
            )}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Gender')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.gender}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Which Describes Racial Background')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.race}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Are You Spanish')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.renderEthnicity()}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Marital Status')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.maritalStatus}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('What Is Your Highest Education')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.education}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Decision Counselor')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.counselorFirstName} {this.state.counselorLastName}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography align="right">{t('Counselor Comments')}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{this.state.counselorComments}</Typography>
        </Grid>

      </Grid>
    )
  }
}

export default translate()(ViewProfileModal)


// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Modals/Profile.js